// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-title {
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.btTop {
  text-align: right;
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.btTop > * {
  margin-left: 1rem;
}

.flex-container {
  display: flex;
  height: 100%;
  gap: 20px;
}
.flex-container .item1 {
  flex-grow: 0;
}
.flex-container .item2 {
  flex-grow: 1;
}

.field--full {
  flex: 1 1 100%;
  min-width: 100%;
}

.threshold-progress-field {
  margin-top: 0.5rem;
}

.threshold-progress-hint {
  margin: 0 0 0.75rem 0;
  color: #555;
  font-size: 0.95rem;
}

.threshold-progress-badge {
  display: inline-block;
  margin-left: 0.5rem;
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
  background: #fdecea;
  color: #c0392b;
  font-size: 0.8rem;
  font-weight: 600;
}

.threshold-progress {
  max-width: 520px;
}

.threshold-progress__track {
  position: relative;
  height: 12px;
  border-radius: 6px;
  background: #e8ecef;
  overflow: visible;
}

.threshold-progress__fill {
  height: 100%;
  border-radius: 6px;
  background: linear-gradient(90deg, #3498db, #2980b9);
  transition: width 0.25s ease;
}

.threshold-progress__fill--warn {
  background: linear-gradient(90deg, #e67e22, #d35400);
}

.threshold-progress__marker {
  position: absolute;
  top: -4px;
  width: 3px;
  height: 20px;
  margin-left: -1.5px;
  border-radius: 1px;
  background: #2c3e50;
  box-shadow: 0 0 0 2px #fff;
  z-index: 1;
}

.threshold-progress__axis {
  display: flex;
  justify-content: space-between;
  margin-top: 0.35rem;
  font-size: 0.8rem;
  color: #7f8c8d;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/marketing/campaign/campaign-detail/campaign-detail.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,qBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AAAI;EACI,iBAAA;AAER;;AACA;EACI,aAAA;EACA,YAAA;EACA,SAAA;AAEJ;AAAI;EACI,YAAA;AAER;AACI;EACI,YAAA;AACR;;AAIA;EACI,cAAA;EACA,eAAA;AADJ;;AAIA;EACI,kBAAA;AADJ;;AAIA;EACI,qBAAA;EACA,WAAA;EACA,kBAAA;AADJ;;AAIA;EACI,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AADJ;;AAIA;EACI,gBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,YAAA;EACA,kBAAA;EACA,oDAAA;EACA,4BAAA;AADJ;;AAIA;EACI,oDAAA;AADJ;;AAIA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,UAAA;AADJ;;AAIA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AADJ;AACA,o8GAAo8G","sourcesContent":[".section-title {\n    margin-top: 1.5rem;\n    margin-bottom: 0.5rem;\n    font-weight: 600;\n}\n\n.btTop {\n    text-align: right;\n    margin-bottom: 1rem;\n    margin-top: 1rem;\n    > * {\n        margin-left: 1rem;\n    }\n}\n.flex-container {\n    display: flex;\n    height: 100%;\n    gap: 20px;\n\n    .item1 {\n        flex-grow:0;\n    }\n\n    .item2 {\n        flex-grow:1;\n    }\n}\n\n\n.field--full {\n    flex: 1 1 100%;\n    min-width: 100%;\n}\n\n.threshold-progress-field {\n    margin-top: 0.5rem;\n}\n\n.threshold-progress-hint {\n    margin: 0 0 0.75rem 0;\n    color: #555;\n    font-size: 0.95rem;\n}\n\n.threshold-progress-badge {\n    display: inline-block;\n    margin-left: 0.5rem;\n    padding: 0.15rem 0.5rem;\n    border-radius: 4px;\n    background: #fdecea;\n    color: #c0392b;\n    font-size: 0.8rem;\n    font-weight: 600;\n}\n\n.threshold-progress {\n    max-width: 520px;\n}\n\n.threshold-progress__track {\n    position: relative;\n    height: 12px;\n    border-radius: 6px;\n    background: #e8ecef;\n    overflow: visible;\n}\n\n.threshold-progress__fill {\n    height: 100%;\n    border-radius: 6px;\n    background: linear-gradient(90deg, #3498db, #2980b9);\n    transition: width 0.25s ease;\n}\n\n.threshold-progress__fill--warn {\n    background: linear-gradient(90deg, #e67e22, #d35400);\n}\n\n.threshold-progress__marker {\n    position: absolute;\n    top: -4px;\n    width: 3px;\n    height: 20px;\n    margin-left: -1.5px;\n    border-radius: 1px;\n    background: #2c3e50;\n    box-shadow: 0 0 0 2px #fff;\n    z-index: 1;\n}\n\n.threshold-progress__axis {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 0.35rem;\n    font-size: 0.8rem;\n    color: #7f8c8d;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
